import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class JobDetailsMenu extends Component {
  render() {
    return (
      <div className="job_details__menu">
        {this.props.children}
      </div>
    );
  }
}

JobDetailsMenu.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

